module.exports = __webpack_public_path__ + "img/12.295b19f1.jpg";